import PackageRow from "./PackageRow";

type Props = { data: any };

const TeamMemberPackageList = ({ data }: Props) => {
  return (
    <div>
      <div className="text-color-primary text-sm mb-4">Packages</div>
      <div className="flex flex-col items-center gap-4 w-full">
        {data?.packages?.map((e: any) => {
          return <PackageRow data={e} />;
        })}
      </div>
    </div>
  );
};

export default TeamMemberPackageList;
